import createTheme from "@mui/material/styles/createTheme";
import {deepPurple, green, lightGreen} from "@mui/material/colors";

export const theme =
  createTheme({
    root: {
      position: 'absolute',
      height: '100%'
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontFamily: "Roboto",
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            fontFamily: "Roboto",
          },
        }
      },
      MuiModal: {
        styleOverrides: {
          root: {
            outline: "none",
            boxShadow: "none",
          },
        },
      },
    },
    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#8491F7',
        contrastText: '#ffffff',
        white: '#ffffff'
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      teal: {
        main: "#D7E8F4",
        contrastText: "#2C2B2A"
      },
      secondary: {
        main: "#2C2B2A",
        contrastText: '#ffffff',
        white: '#ffffff'
      },
      white: "#FFFFFF",
      background1: "#FEFEFE",
      background2: "#EAEAEA",
      // info: {
      //   main: "#1DAEFF",
      //   contrastText: "#FFF"
      // },
      light: {
        main: "#EAEAEA",
        contrastText: "#2C2B2A"
      },
      dark: {
        main: "#2C2B2A",
        contrastText: "#EAEAEA"
      },
      neutral: {
        main: '#ffffff',
        gray: '#f4f6f6',
        gray2: '#adadad',
      },
      azure: {
        default: '#1DAEFF',
        main: '#1DAEFF',
        dark: '#1196e1',
        light: '#1DAEFFee',
        contrastText: "#EAEAEA",
      },
      confirmation: {
        main: '#09D92A',
        contrastText: '#ffffff',
        dark: "#2FA642"
      },
      purple: {
        main: deepPurple[500],
        light: deepPurple[200],
      },
      success: {
        default: lightGreen[600],
        main: lightGreen[600],
        dark: green[800],
        light: green[400],
      }
    },
    typography: {
      fontFamily: "Poppins",
      h1: {
        fontFamily: "Poppins",
        fontSize: '2.8rem'
      },
      h2: {
        fontFamily: "Poppins",
        fontSize: '2.2rem'
      },
      h3: {
        fontFamily: "Poppins",
        fontSize: '1.Poppins'
      },
      h4: {
        fontFamily: "Poppins",
        fontSize: '1.2rem'
      },
      h5: {
        fontFamily: "Poppins",
        fontSize: '1rem'
      },
      body1: {
        fontFamily: "Poppins",
        fontSize: '0.9rem',
        fontWeight: 300
      },
      body2: {
        fontFamily: "Poppins",
        fontSize: '0.8rem',
        fontWeight: 300
      },
      subtitle1: {
        fontFamily: "Poppins",
        fontSize: '0.9rem',
        fontWeight: 300
      },
      subtitle2: {
        fontFamily: "Poppins",
        fontSize: '0.8rem',
        fontWeight: 300
      },
      button: {
        textTransform: "none"
      }

    },
    action: {
      hover: '#1B8EB1',
      active: '#1B8EB1',
    }
  })
